import React, { useState } from 'react';
import Popup from 'reactjs-popup';

const ConfirmModal = ({ isOpen, onClose, onSave, onCancel }) => {
    const [comment, setComment] = useState("");
    const [isFormValid, setIsFormValid] = useState(true);

    const handleCommentChange = (e) => {
        setComment(e.target.value);
    };

    const handleSave = () => {
        if (comment.length > 0) {
            onSave(comment);
            setIsFormValid(true);
        } else {
            setIsFormValid(false);
        }
    };

    return (
        <Popup
            open={isOpen}
            onClose={onClose}
            contentStyle={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: '20px',
                border: '1px solid #d9d7d7',
                borderRadius: '5px',
                backgroundColor: '#fff',
                boxSizing: 'border-box',
            }}
            overlayStyle={{
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                zIndex: 1040,
            }}
        >
            <div className="modal-content" style={{ color: 'darkblue' }}>
                <h5 className='popupTitle'>Reject request</h5>
                <p className='popup-text'>
                    Are you sure you want to reject this event request?
                </p>
                <div className="form-group">
                    <label htmlFor="comment" className='text-label'>Comment<span style={{ color: "red" }}>*</span></label>
                    <textarea
                        id="comment"
                        rows="3"
                        placeholder="I reject this event!"
                        value={comment}
                        onChange={handleCommentChange}
                        className='form-control popup-textarea'
                    />
                    {!isFormValid > 0 && (
                        <span className='popup-text' style={{ color: "red" }}>
                            You must provide a reason for rejection.
                        </span>
                    )}
                </div>
                <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button
                        className="btn btn-cancel"
                        onClick={onCancel}
                    >
                        CANCEL
                    </button>
                    <button
                        className="btn btn-save"
                        onClick={handleSave}
                    >
                        SAVE
                    </button>
                </div>
            </div>
        </Popup>
    );
};

export default ConfirmModal;